import { forwardRef, useImperativeHandle } from 'react';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';
import './CauseAndEffectActivityPrompt.scss';

const defaultProps = {
  causeComponent: null,
  effectComponent: null,
};
const CauseAndEffectActivityPrompt = forwardRef((props, ref) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const {
    causeComponent,
    effectComponent,
  } = mergedProps;
  useImperativeHandle(ref, () => ({
    elementRef: () => { },
  }));

  const createPlaceholder = (title, component) => (
    <div className='card-container'>
      <div className='card-container-placeholder item-placeholder'>
        <div className='title'>
          {title}
        </div>
        <div className='selected-card-container'>
          <div className='selected-card-container-inner'>
            {component}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='cause-and-effect-activity-prompt'>
      {createPlaceholder('Cause', causeComponent)}
      <div>
        <DoubleArrowIcon className='arrow' />
      </div>
      {createPlaceholder('Effect', effectComponent)}
    </div>
  );
});

export default CauseAndEffectActivityPrompt;
